<template>
  <v-menu transition="slide-y-transition" offset-y bottom left>
    <template #activator="{ on: menuOn }">
      <v-btn icon v-on="menuOn">
        <v-tooltip bottom>
          <template #activator="{ on }">
            <v-icon v-on="on">mdi-apps</v-icon>
          </template>
          <span>Acelerex apps</span>
        </v-tooltip>
      </v-btn>
    </template>
    <v-card flat width="280">
      <v-row no-gutters class="ma-2">
        <v-col v-for="app in appList" :key="app.name" cols="6" align-self="center">
          <a :href="app.url" target="_blank">
            <v-card class="text-center card" flat :disabled="app.disabled">
              <img
                v-if="app.imgUrl"
                :src="getImgUrl(app.imgUrl)"
                height="50"
                :class="{ disabled: app.disabled }"
              />
              <v-icon
                v-else-if="app.icon"
                x-large
                class="my-2"
                color="primary"
                :disabled="app.disabled"
              >
                {{ app.icon }}
              </v-icon>
              <p :class="`text-center text-body-2 ${app.disabled ? 'text--disabled' : ''}`">
                {{ app.name }}
              </p>
            </v-card>
          </a>
        </v-col>
      </v-row>
    </v-card>
  </v-menu>
</template>

<script>
export default {
  name: "AppMenu",
  components: {},
  mixins: [],
  props: {},
  data() {
    return {
      appList: {
        dataService: {
          name: "Data Services",
          url: `https://dataservices${
            process.env.NODE_ENV === "production" ? "" : ".staging"
          }.acelerex.com/`,
          disabled: false,
          imgUrl: "svg/data-services.svg",
        },
        automation: {
          name: "Automation",
          url: `https://automation${
            process.env.NODE_ENV === "production" ? "" : ".staging"
          }.acelerex.com/`,
          disabled: false,
          imgUrl: "svg/automation.svg",
        },
        portal: {
          name: "Portal",
          url: `https://portal${
            process.env.NODE_ENV === "production" ? "" : ".staging"
          }.acelerex.com/`,
          disabled: false,
          imgUrl: "svg/portal.svg",
        },
        website: {
          name: "Website",
          url: "https://acelerex.com/",
          disabled: false,
          icon: "mdi-web",
        },
      },
    };
  },
  computed: {},
  watch: {},
  beforeCreate() {},
  created() {},
  beforeMount() {},
  mounted() {},
  beforeUpdate() {},
  updated() {},
  activated() {},
  deactivated() {},
  beforeDestroy() {},
  destroyed() {},
  methods: {
    getImgUrl(pic) {
      const images = require.context("../assets/", true, /\.svg$/);
      return images(`./${pic}`);
    },
  },
};
</script>

<style scoped>
a {
  text-decoration: none;
}
a > .card:hover {
  background-color: rgba(144, 215, 236, 0.2);
}
.disabled {
  filter: grayscale(100%);
  opacity: 70%;
}
.v-menu__content {
  background-color: white;
}
</style>
